import { LoanStatus } from 'scala-sdk';

export const isLoanStatusIn = (
  status: LoanStatus | undefined,
  statuses: LoanStatus[]
): boolean => status !== undefined && statuses.includes(status);
